/** Keyless Google Maps embed with one pin — the web's only map surface. */
export interface TaskLocation {
  latitude: number;
  longitude: number;
}

export function hasMapLocation(location: TaskLocation | null | undefined): location is TaskLocation {
  return (
    !!location && Number.isFinite(location.latitude) && Number.isFinite(location.longitude)
  );
}

export function googleMapsEmbedSrc(lat: number, lng: number, zoom = 15): string {
  const q = encodeURIComponent(`${lat},${lng}`);
  return `https://maps.google.com/maps?q=${q}&z=${zoom}&hl=en&output=embed`;
}

/** Same embed, no search pin — used when we draw `TaskMapMarker` ourselves. */
export function googleMapsViewSrc(lat: number, lng: number, zoom = 15): string {
  return `https://maps.google.com/maps?ll=${lat},${lng}&z=${zoom}&hl=en&output=embed`;
}
